// @ constants
const actionTypes = require('constants/actionTypes');

const reset = () => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_RESET,
});

const toggleAddForm = (visible) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_TOGGLE_ADD_FORM,
    payload: {
        visible
    }
});

const setField = (field, value) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_SET_FIELD,
    payload: {
        field,
        value
    }
});

const setFormField = (id, fieldName, value) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_SET_FORM_FIELD,
    payload: {
        id,
        fieldName,
        value,
    }
});

const validateFormField = (id, fieldName) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_VALIDATE_FORM_FIELD,
    payload: {
        id,
        fieldName,
    }
});

const validateForm = (id) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_VALIDATE_FORM,
    payload: {
        id,
    }
});

const validateStep = () => (dispatch, getState) => {
    const immOpenYoungTaxData = getState().openYoungTaxData;
    if (immOpenYoungTaxData.getIn(['hasTaxData', 'value'])) {
        immOpenYoungTaxData.get('editingById')
            .filter(immTaxDataItem => immTaxDataItem.get('isEditing'))
            .forEach((immTaxDataItem, id) => dispatch(validateForm(id)));
    }
    dispatch({
        type: actionTypes.OPEN_YOUNG_TAX_DATA_VALIDATE_STEP,
    });
};

const addNew = (id) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_ADD_NEW,
    payload: {
        id
    }
});

const remove = (id) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_REMOVE,
    payload: {
        id
    }
});

const startEdit = (id) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_START_EDIT,
    payload: {
        id
    }
});

const updateById = (id) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_UPDATE,
    payload: {
        id
    }
});

const validateAndSave = (id, update = false) => (dispatch, getState) => {
    dispatch(validateForm(id));
    if(getState().openYoungTaxData.getIn(['editingById', id, 'isValid'])){
        if (update) {
            dispatch(updateById(id));
        } else {
            dispatch(addNew(id));
        }
    }
};

const cancelUpdate = (id) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_CANCEL_UPDATE,
    payload: {
        id
    }
});

const cancelAddNew = () => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_CANCEL_ADD_NEW,
});

const cancel = (id, update = false) => dispatch => {
    if(update) {
        dispatch(cancelUpdate(id));
    } else {
        dispatch(cancelAddNew());
    }
};

const fillOpenYoungProfile = (immCountriesTributation) => ({
    type: actionTypes.OPEN_YOUNG_TAX_DATA_FILL_OPENYOUNG_PROFILE,
    payload: {
        immCountriesTributation
    }
});

module.exports = {
    cancel,
    remove,
    reset,
    setField,
    setFormField,
    fillOpenYoungProfile,
    startEdit,
    toggleAddForm,
    updateById,
    validateAndSave,
    validateForm,
    validateFormField,
    validateStep,
};
